<template>
    <label :for="id + 'input-' + (mul ? 'mul' : 'single')" class="drop rounded-xl">
        <div class="text-warning" 
            :class="{'over': isDragging, 'error': wrongFile}"
            @dragover.prevent="dragOver" 
            @dragleave.prevent="dragLeave"
            @drop.prevent="drop($event)"
        >
            <img src="/media/svg/image-placeholder.svg" class="my-auto" alt="placeholder image">
            <div class="pt-3">
                {{ title }}
                <v-icon color="warning">mdi-plus</v-icon>
            </div>
            <input v-if="mul" type="file" multiple :id="id + 'input-mul'" @change="drop($event)" class="d-none" >
            <input v-else type="file" :id="id + 'input-single'" @change="drop($event)" class="d-none" >
        </div>
    </label>
</template>
<style lang="scss">
    .drop {
        cursor: pointer;
        transition: all .4s ease-in-out;
        width: 100%;
        height: 200px;
        display: flex;
        background: #E9E8E8;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 12px;
        margin-top: 16px;
    }
    .over {
        background: #85e783;
   }
</style>
<script>
export default {
    name: "drag-drop-image",
    data: () => ({
        isDragging: false,
        wrongFile: false
    }),
    props: {
        title: String,
        mul: Boolean,
        id: String
    },
    methods: {
        dragOver(){
            this.isDragging = true;
        },
        dragLeave(){
            this.isDragging = false;
        },
        drop(e){
            let files = e.dataTransfer == null ? e.target.files : e.dataTransfer.files;
            this.wrongFile = false;
            this.isDragging = false;
            // allows only 1 file
            if(files.length === 0){}
            else if (files.length === 1 && !this.mul) {
                let file = files[0];
                // allows image only
                if (file.type.indexOf('image/') >= 0) {
                    this.$emit("uploaded", file)
                } else {
                    this.wrongFile = true;
                    this.$emit("inValidFile");
                    setTimeout(() => {
                        this.wrongFile = false;
                    }, 300)
                }
            } else {
         
                if(files){
                    for (const file of files) {
    
     if (file.type.indexOf('image/') < 0) {
                          this.wrongFile = true;
                    this.$emit("inValidFile");
                    setTimeout(() => {
                        this.wrongFile = false;
                    }, 300)
                    }
}
         
       this.$emit("uploaded", files);

               
                }
            }
        },
    }
}
</script>